// extracted by mini-css-extract-plugin
export var contentBody = "_cr-9";
export var headerImage = "_cr-2";
export var imageButton = "_cr-7";
export var imageButtonIcon = "_cr-8";
export var imageHeader = "_cr-4";
export var imageHeaderText = "_cr-5";
export var imageOverlay = "_cr-3";
export var imageTitle = "_cr-6";
export var imageWrapper = "_cr-1";
export var taskList = "_cr-a";
export var widget = "_cr-0";